var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"TextQuestion"}},[_c('p',{staticClass:"dmh-confirm-text",class:[_vm.isWhiteSpacePreWrap ? 'pre-wrap' : 'custom-space'],domProps:{"innerHTML":_vm._s(_vm.decodeData(_vm.question.sub_text))}})])}
var staticRenderFns = []

export { render, staticRenderFns }